import React from 'react';

export default function Alert({ type = 'error', children }) {
  const styles = {
    error:   { background: 'var(--error-dim)',   color: 'var(--error)',   border: '1px solid var(--border)' },
    success: { background: 'var(--success-dim)', color: 'var(--success)', border: '1px solid var(--border)' },
  };
  return (
    <div style={{
      ...styles[type],
      padding: '10px 14px',
      borderRadius: 'var(--radius)',
      fontSize: '13px',
      marginBottom: '16px',
      lineHeight: '1.5',
    }}>
      {children}
    </div>
  );
}
